export default "__VITE_ASSET__C_7b0sT7__"